import { DocMetaData, FileName, UnixMsString } from "../types"

export const getDocNameMetaData = (fileName: FileName): DocMetaData => {
  try {
    let fileNameElements = fileName.split("___")
    const generatedUnixMs = `${fileNameElements[0]}` as UnixMsString
    const docFamily = fileNameElements[1]
    const docName = fileNameElements.slice(2).join("___").split(".")[0]
    return { generatedUnixMs, docFamily, docName }
  } catch (error) {
    return { generatedUnixMs: "", docFamily: "", docName: "" } as unknown as DocMetaData
  }
}
